// A lot of this file is oddly named, because the underlying `react-select` has some oddly named classes.
import React from "react";
import Select, {
  ActionMeta,
  components,
  OptionTypeBase,
  SingleValueProps,
  ValueType,
} from "react-select";

const { Option } = components;

// CustomDestinationOption is an option for the <Select>. It takes the normal option type (OptionTypeBase) and adds
// an `icon` field to it
export type CustomDestinationOption = {
  icon: React.ReactNode;
} & OptionTypeBase;

// This is the function called onChange for this specialized select component.
export type CustomDestinationChangeFn = (
  value: ValueType<CustomDestinationOption>,
  actionMeta?: ActionMeta<CustomDestinationOption>
) => void;

// The component that should be used to display an option in the dropdown
const CustomSelectOption: React.FC<SingleValueProps<
  CustomDestinationOption
>> = (props) => {
  return (
    // @ts-ignore
    <Option {...props}>
      <div className="input-select__single-value">
        {props.data.icon && (
          <span
            className="mr-2 align-middle"
            style={{ position: "relative", top: "-2px" }}
          >
            {props.data.icon}
          </span>
        )}
        <span className="align-middle">{props.data.label}</span>
      </div>
    </Option>
  );
};

// The component that should be used to display the currently selected value in the dropdown.
const CustomSingleValue: React.FC<SingleValueProps<
  CustomDestinationOption
>> = ({ data }) => (
  <div className="input-select" key={data.value}>
    <div className="input-select__single-value">
      {data.icon && (
        <span
          className="mr-2 align-middle"
          style={{ position: "relative", top: "-2px" }}
        >
          {data.icon}
        </span>
      )}
      <span className="align-middle">{data.label}</span>
    </div>
  </div>
);

// Uses react-select custom Select component to create a dropdown to select destinations.
const DestinationSelect: React.FC<
  React.PropsWithoutRef<any> & {
    onChange: CustomDestinationChangeFn;
    options?: CustomDestinationOption[];
  }
> = ({ onChange, options, ...props }) => {
  return (
    <Select
      {...props}
      placeholder="Choose a destination..."
      options={options}
      onChange={onChange}
      components={{
        SingleValue: CustomSingleValue,
        Option: CustomSelectOption,
      }}
    />
  );
};

export { DestinationSelect };
